import { appManager, AppState } from '../manager';
import { SyntheticBondChartsResponse } from './types';

export const fetchSyntheticBondCharts = appManager.createApi<
  Record<string, never>,
  SyntheticBondChartsResponse,
  AppState
>('FETCH_SYNTHETIC_BOND_CHARTS', {
  path: '/synthetic_bond_playground/get_charts_data',
  method: 'GET',
  startReducer(state) {
    state.synthetic_bond_playground.fetching = true;
    state.synthetic_bond_playground.error = undefined;
  },
  failReducer(state, error) {
    state.synthetic_bond_playground.fetching = false;
    state.synthetic_bond_playground.error = error.toString();
  },
  successReducer(state, result) {
    state.synthetic_bond_playground.bonds = result.bonds;
    state.synthetic_bond_playground.fetching = false;
    state.synthetic_bond_playground.fetched = true;
  },
});
